import { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../context/AuthContext'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import CardDisplay from './components/CardDisplay'
import CardActions from './components/CardActions'
import LoadingSpinner from '../../components/LoadingSpinner'

export default function MembershipCard() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [supporter, setSupporter] = useState(null)
  const [isPaid, setIsPaid] = useState(false)
  const [loading, setLoading] = useState(true)
  const cardRef = useRef(null)

  useEffect(() => {
    if (!user) { navigate('/login'); return }
    const fetchSupporter = async () => {
      const { data } = await supabase
        .from('supporters')
        .select('*, chapters(name, region), clubs(name, primary_color)')
        .eq('id', user.id).single()
      if (data) setSupporter(data)

      const { data: sub } = await supabase
        .from('subscriptions').select('valid_until')
        .eq('supporter_id', user.id).order('valid_until', { ascending: false }).limit(1).single()
      if (sub && new Date(sub.valid_until) >= new Date()) setIsPaid(true)

      setLoading(false)
    }
    fetchSupporter()
  }, [user, navigate])

  if (loading) {
    return <LoadingSpinner fullScreen message="Loading your membership card..." />
  }

  return (
    <div className="relative min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col overflow-hidden">

      {/* Watermark */}
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-[0.08] dark:opacity-[0.06] pointer-events-none"
        style={{ backgroundImage: "url('/images/dsms_watermark.png')" }}
      />

      <Navbar />
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-4 sm:px-8 py-10 sm:py-16">
        <div className="text-xs text-gray-500 uppercase tracking-widest mb-6 sm:mb-8">
          Your Digital Membership Card
        </div>

        {/* Blurred card for unpaid */}
        <div className={`transform scale-[0.82] sm:scale-90 lg:scale-100 origin-top relative ${!isPaid ? 'select-none' : ''}`}>
          <div className={!isPaid ? 'blur-sm pointer-events-none' : ''}>
            <CardDisplay ref={cardRef} supporter={supporter} />
          </div>

          {/* Lock overlay */}
          {!isPaid && (
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <div className="bg-white dark:bg-black/80 border border-gray-200 dark:border-white/20 px-6 py-5 text-center shadow-xl">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-yellow-500 mx-auto mb-3">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
                <div className="font-black text-sm uppercase tracking-widest text-gray-900 dark:text-white mb-1">
                  Membership Not Active
                </div>
                <p className="text-xs text-gray-500 leading-relaxed">
                  Pay your subscription to unlock your card
                </p>
              </div>
            </div>
          )}
        </div>

        <CardActions cardRef={cardRef} isPaid={isPaid} />
      </div>
      <Footer />
    </div>
  )
}